import {
  Role,
  MemberEmailStatus,
  RoleType,
  NetworkStatus,
} from '@tribeplatform/gql-client/types'

export const isMemberNotConfirmed = (member, role?: Role): boolean =>
  !!member &&
  member.emailStatus !== MemberEmailStatus.verified &&
  role?.type === RoleType.guest

export const isUrlPointsWithinApp = (url: string): boolean =>
  url.startsWith('/oauth/') === false &&
  url.startsWith('/auth') === false &&
  url.startsWith('/api/analytics') === false &&
  url.startsWith('/manifest.json') === false &&
  url.startsWith('sw.js') === false &&
  url.startsWith('favicon.ico') === false &&
  url.startsWith('/ssos/redirect') === false

export const isRestricted = (
  roleType: RoleType,
  networkStatus: NetworkStatus,
  url: string,
): boolean => {
  const isAdmin = roleType === RoleType.admin
  const isUnpublished = networkStatus === NetworkStatus.unpublished
  const isArchived = networkStatus === NetworkStatus.archived

  if (isArchived && !url.startsWith('/auth/restricted')) {
    return true
  }

  // For admins everything is allowed.
  // For guests and regular members, only login page is allowed.
  const isURLAllowed =
    isAdmin ||
    url.startsWith('/auth/login') ||
    url.startsWith('/auth/restricted')

  return isUnpublished && !isURLAllowed
}

type TGenerateLoginUrl = (opts: {
  redirect?: string
  disableAutoLogin?: boolean
}) => string

export const generateLoginUrl: TGenerateLoginUrl = ({
  redirect,
  disableAutoLogin,
}) => {
  const params = new URLSearchParams()
  if (redirect) {
    params.append('redirect', encodeURIComponent(redirect))
  }

  if (disableAutoLogin) {
    params.append('auto_login', 'false')
  }
  const query = params.toString()
  return `/auth/login${query.length ? `?${query}` : ''}`
}

export const generateMemberVerificationUrl = (memberId: string): string => {
  return `/auth/verify?memberId=${memberId}`
}
